var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "selector"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "latitude"
    }
  }, [_vm._v(_vm._s(_vm.$t("location.latitude")))]), _c('input', {
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.validationErrors.latitude
    },
    attrs: {
      "id": "latitude",
      "type": "number",
      "min": "-90",
      "max": "90",
      "step": "0.000001",
      "placeholder": _vm.$t('location.enter_latitude')
    },
    domProps: {
      "value": _vm.data.latitude
    },
    on: {
      "input": _vm.handleLatitudeInput
    }
  }), _vm.validationErrors.latitude ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" " + _vm._s(_vm.validationErrors.latitude) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "longitude"
    }
  }, [_vm._v(_vm._s(_vm.$t("location.longitude")))]), _c('input', {
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.validationErrors.longitude
    },
    attrs: {
      "id": "longitude",
      "type": "number",
      "min": "-180",
      "max": "180",
      "step": "0.000001",
      "placeholder": _vm.$t('location.enter_longitude')
    },
    domProps: {
      "value": _vm.data.longitude
    },
    on: {
      "input": _vm.handleLongitudeInput
    }
  }), _vm.validationErrors.longitude ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" " + _vm._s(_vm.validationErrors.longitude) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "col-md-12 d-flex justify-content-end gap-2"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getCurrentLocation
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("location.use_current_location")) + " ")]), _c('button', {
    staticClass: "btn btn-outline-danger",
    attrs: {
      "disabled": _vm.data.latitude == null || _vm.data.longitude == null,
      "type": "button"
    },
    on: {
      "click": _vm.clearCoordinates
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("location.clear_coordinates")) + " ")])])]), _c('div', {
    staticClass: "map"
  }, [_c('l-map', {
    ref: "map",
    staticStyle: {
      "height": "400px",
      "z-index": "0"
    },
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center,
      "options": {
        attributionControl: false,
        doubleClickZoom: false,
        minZoom: 2,
        maxZoom: 18
      }
    },
    on: {
      "click": _vm.handleMapClick
    }
  }, [_c('l-tile-layer', {
    attrs: {
      "url": _vm.url,
      "attribution": null
    }
  }), _vm.markerPosition !== null ? _c('l-marker', {
    attrs: {
      "lat-lng": _vm.markerPosition
    }
  }) : _vm._e()], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }